import { AutoComplete } from './custom-autocomplete';
import { ComboboxMultiple } from './custom-select-multiple';
import SelectPrimitive from './custom-select-primitive';
import { Combobox } from './custom-select-single';
import CustomSelectUnit from './custom-select-unit';
import MultiSelect from './multi-select';

const CustomSelect = {
    /**Default select shadcn */
    Root: SelectPrimitive,
    /**Select with single value */
    Single: Combobox,
    /**Multiple select autocomplete */
    Multiple: ComboboxMultiple,
    /** Select Unit */
    Unit: CustomSelectUnit,
    /**Auto complete */
    Autocomplete: AutoComplete,
    /**Mutiple2 */
    Multiple2: MultiSelect,
    name: 'Custom select',
};

export type * from './custom-select-multiple';
export type * from './custom-select-primitive';
export type * from './custom-select-single';
export type * from './custom-select-unit';
export type * from './custom-autocomplete';
export * from './map-to-option';
export type * from './multi-select';
export default CustomSelect;
